import React from "react";
import Wrapper from "@/scenes/_shared/stages/wrapper";
import useRadioInput, { RadioInput } from "@/components/form/radio-input";

const S14 = (props) => {
    const radio = useRadioInput({
        name: "sale[claim][details]",
        label: "Hva krever du av selger?",
        tooltip: "Du kan velge flere alternativer.",
        options: {
            data: [
                { label: "Undersøkelse", value: "CAR_INSPECTION" },
                { label: "Reparasjon", value: "CAR_REPAIR" },
                { label: "Heving (returnere og få pengene tilbake)", value: "REFUND" },
                { label: "Prisavslag", value: "PRICE_REDUCTION" },
                { label: "Erstatning", value: "COMPENSATION" },
                { label: "Vet ikke", value: "UNSURE" },
            ],
        },
        multiple: true,
        ...props,
    })

    return (
        <Wrapper {...props} header="Fortell oss om kravet ditt">
            <div className="group--flex gg-3">
                <RadioInput {...radio.props}/>
            </div>
        </Wrapper>
    );
};

export default S14;
